import { useDialog } from "@/client/stores/dialog";
import { FilterReferenceUser, FilterResumeType } from "@reactive-resume/dto";
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Form,
  FormField,
  FormItem,
  FormLabel,
  Input,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  FormControl,
  SelectValue,
  SelectTrigger,
  ScrollArea,
} from "@reactive-resume/ui";
import { useRef } from "react";
import { useForm } from "react-hook-form";
import { SelectFormField } from "../_components/select-form-fields";
import { usefilterUser } from "@/client/services/user/filter-user";

import { useFilterReference } from "@/client/stores/filter";

export const FilterReferenceDialog = () => {
  type FormValue = FilterReferenceUser;
  const formRef = useRef<HTMLFormElement>(null);
  const { replaceFilter } = useFilterReference();
  const { filterUsers } = usefilterUser(false);
  const { isOpen, mode, close } = useDialog("filter-reference");
  const form = useForm<FormValue>({
    defaultValues: {
      upUserId: "",
      downUserId: "",
    },
  });
  const OnSubmit = (data: FormValue) => {
    try {
      console.log(data);
      replaceFilter(data);
      form.reset();
      close();
    } catch {
      form.reset();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={close}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Filtrer les parrainnages</DialogTitle>
        </DialogHeader>
        <Form {...form}>
          <form
            ref={formRef}
            onSubmit={form.handleSubmit(OnSubmit)}
            className="flex flex-col gap-y-4"
          >
            <div className="flex flex-row gap-2">
              <div className="flex w-1/2 flex-col gap-2">
                <FormField
                  name="upUserId"
                  render={({ field }) => (
                    <FormItem className="w-full">
                      <FormLabel> Referent </FormLabel>
                      <Select
                        value={field.value}
                        onValueChange={(value) => {
                          field.onChange(value);
                        }}
                      >
                        <FormControl>
                          <SelectTrigger className="w-full">
                            <SelectValue placeholder="Sélectionner un client" />
                          </SelectTrigger>
                        </FormControl>
                        <SelectContent>
                          <ScrollArea orientation="vertical" className="h-[300px]">
                            {/* <SelectGroup> */}
                            {/* <SelectLabel>Selectionner un client</SelectLabel> */}
                            {filterUsers?.data
                              .slice()
                              .sort((a, b) => a.name.localeCompare(b.name))
                              .map((item) => {
                                return (
                                  <>
                                    <SelectItem value={item.id}>
                                      {" "}
                                      <span className="font-bold">{item.name}</span> ||{" "}
                                      <span className="text-moncvpro-secondary text-lg font-bold">
                                        {" "}
                                        {item.email}
                                      </span>
                                    </SelectItem>
                                  </>
                                );
                              })}
                            {/* </SelectGroup> */}
                          </ScrollArea>
                        </SelectContent>
                      </Select>
                    </FormItem>
                  )}
                />
              </div>
              <div className="flex w-1/2 flex-col gap-2">
                {" "}
                <FormField
                  name="downUserId"
                  render={({ field }) => (
                    <FormItem className="w-full">
                      <FormLabel> Referé </FormLabel>
                      <Select
                        value={field.value}
                        onValueChange={(value) => {
                          field.onChange(value);
                        }}
                      >
                        <FormControl>
                          <SelectTrigger className="w-full">
                            <SelectValue placeholder="Sélectionner un client" />
                          </SelectTrigger>
                        </FormControl>
                        <SelectContent>
                          <ScrollArea orientation="vertical" className="h-[300px]">
                            {/* <SelectGroup> */}
                            {/* <SelectLabel>Selectionner un client</SelectLabel> */}
                            {filterUsers?.data
                              .slice()
                              .sort((a, b) => a.name.localeCompare(b.name))
                              .map((item) => {
                                return (
                                  <>
                                    <SelectItem value={item.id}>
                                      {" "}
                                      <span className="font-bold">{item.name}</span> ||{" "}
                                      <span className="text-moncvpro-secondary text-lg font-bold">
                                        {" "}
                                        {item.email}
                                      </span>
                                    </SelectItem>
                                  </>
                                );
                              })}
                            {/* </SelectGroup> */}
                          </ScrollArea>
                        </SelectContent>
                      </Select>
                    </FormItem>
                  )}
                />
              </div>
            </div>
            <div className="flex flex-row gap-2">
              <div className="flex w-1/2 flex-col gap-2">
                <FormField
                  name="status"
                  render={({ field }) => (
                    <FormItem className="w-full">
                      <FormLabel> Statut </FormLabel>
                      <Select
                        value={field.value}
                        onValueChange={(value) => {
                          field.onChange(value);
                        }}
                      >
                        <FormControl>
                          <SelectTrigger className="w-full">
                            <SelectValue placeholder="Sélectionner un statut" />
                          </SelectTrigger>
                        </FormControl>
                        <SelectContent>
                          <SelectGroup>
                            <SelectItem value="opened">Activé</SelectItem>
                            <SelectItem value="closed">Fermé</SelectItem>
                          </SelectGroup>
                        </SelectContent>
                      </Select>
                    </FormItem>
                  )}
                />
              </div>
            </div>

            <div className="flex justify-center gap-x-3">
              <Button type="submit" className="bg-moncvpro-secondary">
                {"Valider"}
              </Button>
            </div>
          </form>
        </Form>
      </DialogContent>
      <DialogFooter></DialogFooter>
    </Dialog>
  );
};
